import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03c19746"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card my-5" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "pb-3" }
const _hoisted_4 = { class: "fw-bold d-flex align-items-center text-dark" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "row mb-5" }
const _hoisted_7 = {
  href: "https://www.google.com/",
  target: "_blank",
  rel: "noopener noreferrer",
  style: {"color":"#409eff","text-decoration":"underline"}
}
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6 pb-2" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 pb-2" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-6 pb-2" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-4 col-lg-6 mb-5" }
const _hoisted_16 = {
  key: 0,
  class: "col-lg-4 col-md-6 mb-5"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-4 col-lg-6 mb-5" }
const _hoisted_19 = {
  key: 0,
  class: "col-lg-4 col-md-6 mb-5"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-lg-4 col-lg-6 mb-5" }
const _hoisted_22 = {
  key: 0,
  class: "col-lg-4 col-md-6 mb-5"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-lg-6 pb-2" }
const _hoisted_25 = { class: "card my-5" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "pb-3" }
const _hoisted_28 = { class: "fw-bold d-flex align-items-center text-dark" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_30 = { class: "card my-5" }
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { class: "pb-3" }
const _hoisted_33 = { class: "fw-bold d-flex align-items-center text-dark" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_35 = { class: "row pb-2" }
const _hoisted_36 = { class: "col-lg-6 pb-2" }
const _hoisted_37 = { class: "col-lg-6 pb-2" }
const _hoisted_38 = { class: "row pb-2" }
const _hoisted_39 = { class: "col-lg-6 pb-2" }
const _hoisted_40 = { class: "row pb-2" }
const _hoisted_41 = { class: "col-lg-6 pb-2" }
const _hoisted_42 = { class: "col-lg-6 pb-2" }
const _hoisted_43 = { class: "row pb-2" }
const _hoisted_44 = { class: "col-lg-8 pb-2" }
const _hoisted_45 = { class: "w-150px" }
const _hoisted_46 = { class: "row pb-2" }
const _hoisted_47 = { class: "col-lg-8 pb-2" }
const _hoisted_48 = { class: "w-150px" }

import { ref, inject, onMounted } from "vue";
import {
  investorDistinctionSelection,
  moneyRange,
  mainIncomeSources,
  transactionMotives,
  mainFunds,
  experienceSelections,
  investmentPurposes,
  assetManagementPeriodSelection,
  financialInstiutionTypes,
  depositTypesSelection,
} from "@/core/types/jp/verificationFinancial";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductFinancial',
  setup(__props) {

const items = inject<any>("items");
const formData = inject<any>("formData");
const isSubmitting = inject<any>("isSubmitting");

const item = ref<any>(items?.value?.data?.financial || {});

onMounted(() => {
  formData.value = item.value;
});

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.financial")), 1)
        ]),
        _hoisted_5,
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.investorDistinction'),
          prop: "investorDistinction"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: _unref(formData).investorDistinction,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).investorDistinction) = $event)),
              disabled: _unref(isSubmitting)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(investorDistinctionSelection), (item) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: item.value,
                    label: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t("fields.aboutInvestorClassification")), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.annualIncome'),
              prop: "annualIncome"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).annualIncome,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).annualIncome) = $event)),
                  disabled: _unref(isSubmitting),
                  placeholder: _ctx.$t('fields.select'),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moneyRange), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.valueOfInvestment'),
              prop: "investment"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).investment,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).investment) = $event)),
                  disabled: _unref(isSubmitting),
                  placeholder: _ctx.$t('fields.select'),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moneyRange), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.amountOfInvestmentFunds'),
              prop: "investmentFunds"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).investmentFunds,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).investmentFunds) = $event)),
                  disabled: _unref(isSubmitting),
                  placeholder: _ctx.$t('fields.select'),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moneyRange), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.mainSourceOfIncome'),
              prop: "mainIncomeSource"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).mainIncomeSource,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).mainIncomeSource) = $event)),
                  placeholder: _ctx.$t('fields.select'),
                  style: {"width":"100%"},
                  clearable: "",
                  disabled: _unref(isSubmitting)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainIncomeSources), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          (_unref(formData).mainIncomeSource == 7)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_el_form_item, { label: " " }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-250px",
                      modelValue: _unref(formData).mainIncomeSourceOther,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).mainIncomeSourceOther) = $event)),
                      disabled: _unref(isSubmitting)
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.transactionMotive'),
              prop: "transactionMotive"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).transactionMotive,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).transactionMotive) = $event)),
                  placeholder: _ctx.$t('fields.select'),
                  style: {"width":"100%"},
                  clearable: "",
                  disabled: _unref(isSubmitting)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transactionMotives), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          (
            _unref(formData).transactionMotive == 6 || _unref(formData).transactionMotive == 5
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(_component_el_form_item, { label: " " }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-250px",
                      modelValue: _unref(formData).transactionMotiveOther,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).transactionMotiveOther) = $event)),
                      disabled: _unref(isSubmitting)
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.characteristicsOfMainFunds'),
              prop: "mainFund"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).mainFund,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).mainFund) = $event)),
                  placeholder: _ctx.$t('fields.select'),
                  style: {"width":"100%"},
                  clearable: "",
                  disabled: _unref(isSubmitting)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mainFunds), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          (_unref(formData).mainFund == 6 || _unref(formData).mainFund == 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createVNode(_component_el_form_item, { label: " " }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-250px",
                      modelValue: _unref(formData).mainFundOther,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formData).mainFundOther) = $event)),
                      disabled: _unref(isSubmitting)
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.assetManagementPeriod'),
              prop: "assetManagementPeriod"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).assetManagementPeriod,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(formData).assetManagementPeriod) = $event)),
                  disabled: _unref(isSubmitting),
                  placeholder: _ctx.$t('fields.select'),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(assetManagementPeriodSelection), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("h2", _hoisted_28, _toDisplayString(_ctx.$t("title.relevantTradingExperience")), 1)
        ]),
        _hoisted_29,
        _createVNode(_component_el_form_item, {
          label: 'FX' + ' (' + _ctx.$t('fields.foreignExchangeMarginTrading') + ')',
          prop: "fx",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).fx,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formData).fx) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(isSubmitting)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(experienceSelections), (v_item, index) => {
                  return (_openBlock(), _createBlock(_component_el_radio_button, {
                    key: index,
                    label: v_item.value,
                    class: "col-lg-4 col-md-6 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(v_item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.stockTradingSpot'),
          prop: "stockTradingSpot",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).stockTradingSpot,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formData).stockTradingSpot) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(isSubmitting)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(experienceSelections), (v_item, index) => {
                  return (_openBlock(), _createBlock(_component_el_radio_button, {
                    key: index,
                    label: v_item.value,
                    class: "col-lg-4 col-md-6 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(v_item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.stockTradingCredit'),
          prop: "stockTradingCredit",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).stockTradingCredit,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(formData).stockTradingCredit) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(isSubmitting)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(experienceSelections), (v_item, index) => {
                  return (_openBlock(), _createBlock(_component_el_radio_button, {
                    key: index,
                    label: v_item.value,
                    class: "col-lg-4 col-md-6 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(v_item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.indexOption'),
          prop: "indexOption",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).indexOption,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(formData).indexOption) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(isSubmitting)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(experienceSelections), (v_item, index) => {
                  return (_openBlock(), _createBlock(_component_el_radio_button, {
                    key: index,
                    label: v_item.value,
                    class: "col-lg-4 col-md-6 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(v_item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.commodityFuturesTrading'),
          prop: "commodityFuturesTrading",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).commodityFuturesTrading,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(formData).commodityFuturesTrading) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(isSubmitting)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(experienceSelections), (v_item, index) => {
                  return (_openBlock(), _createBlock(_component_el_radio_button, {
                    key: index,
                    label: v_item.value,
                    class: "col-lg-4 col-md-6 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(v_item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.otherDerivativesTransaction'),
          prop: "otherDerivativesTransaction",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).otherDerivativesTransaction,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(formData).otherDerivativesTransaction) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(isSubmitting)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(experienceSelections), (v_item, index) => {
                  return (_openBlock(), _createBlock(_component_el_radio_button, {
                    key: index,
                    label: v_item.value,
                    class: "col-lg-4 col-md-6 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(v_item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.investmentPurpose'),
          prop: "investmentPurpose",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_checkbox_group, {
              modelValue: _unref(formData).investmentPurpose,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(formData).investmentPurpose) = $event)),
              size: "large",
              class: "row",
              disabled: _unref(isSubmitting)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(investmentPurposes), (v_item, index) => {
                  return (_openBlock(), _createBlock(_component_el_checkbox, {
                    key: index,
                    label: v_item.value,
                    class: "col-lg-3 col-md-6 mb-3"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(v_item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("h2", _hoisted_33, _toDisplayString(_ctx.$t("title.marginReturnAccount")), 1)
        ]),
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.financialInstiutionName'),
              prop: "financialInstiutionName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).financialInstiutionName,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(formData).financialInstiutionName) = $event)),
                  disabled: _unref(isSubmitting)
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.financialInstiutionType'),
              prop: "financialInstiutionType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(formData).financialInstiutionType,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(formData).financialInstiutionType) = $event)),
                  placeholder: _ctx.$t('fields.select')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(financialInstiutionTypes), (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.financialInstitutionCode'),
              prop: "financialInstitutionCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).financialInstitutionCode,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(formData).financialInstitutionCode) = $event)),
                  disabled: _unref(isSubmitting)
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.branchName'),
              prop: "branchName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).branchName,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(formData).branchName) = $event)),
                  disabled: _unref(isSubmitting)
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.branchCode'),
              prop: "branchCode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).branchCode,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(formData).branchCode) = $event)),
                  disabled: _unref(isSubmitting)
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('fields.depositType'),
          prop: "depositType",
          class: "mb-5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(formData).depositType,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(formData).depositType) = $event)),
              disabled: _unref(isSubmitting)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(depositTypesSelection), (item) => {
                  return (_openBlock(), _createBlock(_component_el_radio, {
                    key: item.value,
                    label: item.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.accountHolderFullWidth'),
              prop: "accountHolderFullWidth"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).accountHolderFullWidth,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(formData).accountHolderFullWidth) = $event)),
                  disabled: _unref(isSubmitting)
                }, {
                  append: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t("fields.accountHolderFullWidthSample")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.accountHolderFullWidthKatakana'),
              prop: "accountHolderFullWidthKatakana"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(formData).accountHolderFullWidthKatakana,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(formData).accountHolderFullWidthKatakana) = $event)),
                  disabled: _unref(isSubmitting)
                }, {
                  append: _withCtx(() => [
                    _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("fields.accountHolderFullWidthKatakanaSample")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})